import { apiFetch } from './client';

/**
 * Which page groups this instance can serve.
 *
 * ADR 030 D1: instances differ by what they enable. One frontend build
 * ships in one wheel and serves every instance, so the sidebar cannot know
 * which pages belong — and it did not ask, which is how `wingd` came to
 * offer Knowledge Graph, Health, Pages, Sources and Stage, five pages
 * belonging to another deployment's subject and every one reaching a 503.
 */

/** Every key of `ROUTE_DEPENDENCIES` in `panel/server/routes/__init__.py`. */
export type Capability =
  | 'knowledge.base'
  | 'reflection'
  | 'work.collect'
  | 'work.metrics'
  | 'work.pulse'
  | 'work.trends';

export type Capabilities = Partial<Record<Capability, boolean>>;

export const fetchCapabilities = (): Promise<{
  capabilities: Capabilities;
}> => apiFetch('/api/panel/capabilities');
